import "../../../css/Containers/ContainerStyles.css";
import { ReactNode } from "react";
import { Colors } from "../../../utils/colors";
import { Icon } from "@iconify/react";
import ExpandableBox from "../ExpandableBox";

type SelectableOptionCardProps = {
  title: string | ReactNode;
  subtext?: string;
  isSelected: boolean;
  onSelect: () => void;
  children?: ReactNode;
  disabled?: boolean;
  isError?: boolean;
};

// A bordered selectable container card that displays an option
const SelectableOptionCard = (props: SelectableOptionCardProps) => {
  const { title, subtext, isSelected, onSelect, children, disabled, isError } =
    props;

  const styles = {
    selectableItem: {
      border: isSelected
        ? `1.5px solid ${isError ? Colors.RED3 : Colors.BLACK}`
        : `1.5px solid ${Colors.GRAY2}`,
      borderRadius: 12,
      backgroundColor: isSelected ? Colors.WHITE : Colors.WHITE1,
      padding: 14,
      gap: 14,
    },
  };

  return (
    <ExpandableBox>
      <div
        className="ColumnNormal"
        style={{
          ...styles.selectableItem,
          pointerEvents: disabled ? "none" : "all",
          opacity: disabled ? 0.6 : 1,
          cursor: isSelected && children ? "auto" : "pointer",
        }}
        onClick={isSelected && children ? undefined : onSelect}
      >
        <div
          className="AlignedRowSpacedSelect"
          style={{ gap: 14 }}
          onClick={isSelected && children ? onSelect : undefined}
        >
          <div className="ColumnNormal" style={{ gap: 4 }}>
            {typeof title === "string" ? (
              <span className="bodyMedium">{title}</span>
            ) : (
              title
            )}
            {subtext ? (
              <span className="smallBodySubtext">{subtext}</span>
            ) : null}
          </div>
          <div>
            <Icon
              icon={"ion:checkmark-circle"}
              height={24}
              style={{
                opacity: isSelected ? 1 : 0,
                color: Colors.BLACK,
                transition: "0.3s",
              }}
            />
          </div>
        </div>
        {isSelected && children ? children : null}
      </div>
    </ExpandableBox>
  );
};

export default SelectableOptionCard;
